import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ConfigService } from '../services/config.service';

@Injectable()
export class EventsGuard  {
  constructor(
    private configService: ConfigService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.configService.get().showEventsSection) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
}
